import Regions from './containers/RegionsContainer';

export default Regions;
